import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { RestApiService } from './rest-api.service';


@Injectable({
  providedIn: 'root'
})
export class HomeService {

  constructor(
    private http: HttpClient, 
    private restApiService: RestApiService
    ) { }
    
 


  getSearchTitles(searchValue:string) {

    return of(recent_projects);
    return this.http.post('', {search: searchValue});
  }
  getRecentProjectsList() {
    return of(recent_projects);
// get recent projects through api from below
    return this.http.get('');
  }

  setLocal(key: string, value: string): void {
    localStorage.setItem(key, value);
  }
  getLocal(key: string): any{
    return localStorage.getItem(key);
    
  }
  removeLocal(key: string, value: string): void{
    localStorage.removeItem(key);
  }
  clearLocal(): void {
    localStorage.clear
  }

  //getiing user data



}

const recent_projects = [
  { id: 1, name: 'Bad Boys 3' },
  { id: 2, name: 'Peter Rabbit' },
  { id: 3, name: 'Rock That Body' },
  { id: 4, name: 'Dark Tower' },
  { id: 5, name: 'Passengers' },
  { id: 6, name: 'Life' },
  { id: 7, name: 'Spider man' },
  { id: 8, name: 'Flatliners' },
  { id: 9, name: 'Inferno' },
  { id: 10, name: 'Holmes and Watson' },
];
